<script lang="ts">
    import { v4 as v4uuid } from 'uuid';
    import { subtypesDiligencesService } from "../services";
    import { Icon } from "sveltestrap";
    import { SubtypesDiligences } from "../Model/SubtypesDiligences";
    import AddSubtypeModal from "./AddSubtypeModal.svelte";

    export let diligenceType: string;

    let subtypes: SubtypesDiligences[];

    let diligenceTypeModal = null;
    let addSubtype: boolean = false;
    let editSubtype: SubtypesDiligences;
    let removeButton: boolean;

    $: load(diligenceType);

    async function load(diligenceType){

        subtypes = await subtypesDiligencesService.findByDiligence(diligenceType);        

        subtypes.sort((a,b) => {
            return a.subTypeDiligence < b.subTypeDiligence ? -1 : 1;
        })        
        
    }

    function addNewSubType (subtype){
        if (subtype?.diligenceCode == diligenceTypeModal) {
            
            let subtypeEdit = subtypes.find(s => s.id == subtype.id)

            if (subtypeEdit) {
                subtypeEdit = subtype
            }else{
                subtypes.push(subtype);
            }
            editSubtype = null
            subtype = null
            subtypes = subtypes;
        }
        
    }

    function removeSubType (subtype){
        if (subtype?.diligenceCode == diligenceTypeModal) {

            subtypes.splice(subtypes.findIndex((elemento, indice) => {
                if (elemento.id === subtype.id) {
                    return indice;
                }
            }), 1);
            subtypes = subtypes;
            
        }
        
    }

    function openModal(subtype: SubtypesDiligences = null) {
        addSubtype = true;
        diligenceTypeModal = diligenceType;
        editSubtype = subtype;
        removeButton = (subtype == null) ? false : true;
        if (subtype == null) {
            editSubtype = new SubtypesDiligences({
				id : v4uuid(), 
				diligenceCode : diligenceType,
                subTypeDiligence : '',
                antecedent : 0
			});
        } else {
            editSubtype = subtype;
        }
        
    }

</script>

<style>

</style>

<div class="container-fluid p-5 pt-0">
    <div class="container">
        <div class="row">
            <div class="col-12 text-end">
                <button class="btn btn-primary" type="button" on:click={() => {openModal()}}><Icon name="plus"/> Añadir
                </button>
            </div>
            {#if subtypes?.length}
                {#each subtypes as subtype, index }
                    <div class="col-6">
                        {subtype.subTypeDiligence} 
                        <button class="btn btn-link btn-sm" type="button" on:click={() => {openModal(subtype)}}><Icon name="pencil-square"/>
                        </button>
                    </div>
                {/each}
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h3>No hay subtipos para mostrar</h3>
                </div>
            {/if}
        </div>
    </div>
</div>

<AddSubtypeModal 
    bind:open={addSubtype}  
    type={diligenceTypeModal} 
    editSubtype={editSubtype} 
    removeButton={removeButton}
    on:addSubtype={(event) => addNewSubType (event.detail)}
    on:removeSubtype={(event) => removeSubType (event.detail)}
/>



